import React, { useEffect, useRef, useState } from 'react';
import { connect } from 'react-redux';

import { AuthSelectors } from '@web_opxp/features';
import { LanguageSelectors, useTranslation } from '@web_opxp/language';
import './Day0Banner.scss';
import { isDay0Coupon } from './selectors';
import { getSecondsUntilDay0Expire, parseTime } from './utils';

export interface IDay0BannerProps {
  show: boolean;
  secondsLeft: number;
}

export const Day0BannerFC: React.FC<IDay0BannerProps> = ({ show, secondsLeft }) => {
  const [timer, setTimer] = useState(secondsLeft);
  const { t } = useTranslation();
  const timeout = useRef<number>(undefined);
  const decreaseTimer = () => {
    if (timer < 0) {
      // when timer goes below zero - stop it
      clearTimeout(timeout.current);
      timeout.current = 0;
      return;
    }
    setTimer(timer - 1);
  };
  // countdown effect
  useEffect(() => {
    if (!show) {
      return;
    }
    const timerId = window.setTimeout(decreaseTimer, 1000);
    timeout.current = timerId;
    return () => {
      if (!timeout.current) {
        // do not clear timeout if was already cleared
        return;
      }
      clearTimeout(timeout.current);
    };
  });
  // parsing seconds to timeleft string effect
  const timeLeft = parseTime(timer);

  // do not show banner when timer goes below zero
  if (!show || timer < 0) {
    return null;
  }
  // localize the title
  const title = t('common:Day0Banner.Title', { timeLeft });
  return (
    <div className="day0-banner-container">
      <h3 className="day0-banner">{title}</h3>
    </div>
  );
};

export const mapStateToProps = (state: any) => {
  const created = AuthSelectors.getCreated(state);
  const localeLoaded = !LanguageSelectors.isLoading(state);
  const isDay0 = isDay0Coupon(state);
  const show = isDay0 && localeLoaded;
  const secondsLeft = getSecondsUntilDay0Expire(created);
  return {
    show,
    secondsLeft,
  };
};

const Day0Banner = connect(mapStateToProps, {})(Day0BannerFC);
export default Day0Banner;
